export default "__VITE_ASSET__C2McngL0__"